import { Alert } from "antd";
import { AlertError, FetchError } from "General/ErrorTypes";

interface ErrorProps {
  err: AlertError | FetchError;
}

export const ErrorDisplay = ({ err }: ErrorProps) => {
  let messages;
  if (err.messages) {
    messages = err.messages.map((val) => <li key={`${val}`}>{val}</li>);
  }

  return <Alert title={err.message} description={<ul>{messages}</ul>} type="error" showIcon={true} className="mb-2" />;
};
